<script>
import { movementParameters } from 'config';
import template from '../../views/partials/movements/popup.html';

export default {
  name: 'MovementPopup',
  template,
  props: {
    movement: Object,
  },
  computed: {
    lang() {
      return this.$language.current;
    },
  },
  data() {
    return {
      movementParameters,
    };
  },
};
</script>
